import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/components/settings/notifications-page";

export const Route = createFileRoute("/_dashboard/notifications")({
  component: NotificationsPage,
});
